import axios from 'common/utils/axios';

const activitiesApi = axios('activities');

export const useActivitiesSkills = (params: any) => {
  return activitiesApi.get('skills', { params });
};
